import "./Style/publicpages.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// ---------- Public Pages ----------
import Home from "./PublicPages/Home";
import About from "./PublicPages/About";
import Login from "./PublicPages/Login";
import Register from "./PublicPages/Register";
import ForgotPassword from "./PublicPages/ForgotPassword";
import VerifyOtp from "./PublicPages/VerifyOtp";
import ResetPassword from "./PublicPages/ResetPassword";
import Services from "./PublicPages/Services";
import Resources from "./PublicPages/Resources";
import Features from "./PublicPages/Features";
import Pricing from "./PublicPages/Pricing";
import Contact from "./PublicPages/Contact_Us";
import Communication from "./PublicPages/Communication";
import CustomerServices from "./PublicPages/CustomerServices";
import Promotions from "./PublicPages/Promotions";
import CrmMarketing from "./PublicPages/CrmMarketing";
import DegreeView from "./PublicPages/360-Degree-View";
import DigitalMobile from "./PublicPages/DigitalMobile";
import Planning from "./PublicPages/Planning";
import Analytics from "./PublicPages/Analytics";
import CrmAnalysis from "./PublicPages/CrmAnalysis";
import DigitalMarketing from "./PublicPages/DigitalMarketing";
import PrivacyPolicy from "./PublicPages/PrivacyPolicy";
import OurStory from "./PublicPages/OurStory";
import WhyChooseUs from "./PublicPages/WhyChooseUs";
import TermsOfUse from "./PublicPages/TermsOfUse";
import Lead from "./PublicPages/LeadManagement";
import Inventory from "./PublicPages/InventoryManagement";
import Process from "./PublicPages/ProcessManagement";
import InvoiceManagement from "./PublicPages/InvoiceManagement";
import ContactManagement from "./PublicPages/ContactManagement";
import TaskManagement from "./PublicPages/TaskManagement";
import SalesAutomation from "./PublicPages/SalesAutomation";
import SalesForecasting from "./PublicPages/SalesForecasting";
import DashboardAndReporting from "./PublicPages/DashboardAndReporting";
import ProductivityAnalysis from "./PublicPages/ProductivityAnalysis";
import EmailIntegration from "./PublicPages/EmailIntegration";
import EyeSense from "./PublicPages/EyeSense";
import Career from "./PublicPages/Career";
import ApplyNowForm from "./PublicPages/ApplyNowForm";
import OpportunityManagement from "./PublicPages/OpportunityManagement";
import ChoosingRightCRM from "./PublicPages/ChoosingRightCRM";
import CoreCRMFeatures from "./PublicPages/CoreCRMFeatures";
import OptionalCRMFeatures from "./PublicPages/OptionalCRMFeatures";
import CommonCRMFeatures from "./PublicPages/CommonCRMFeatures";
import StableGrowth from "./PublicPages/StableGrowth";
import ImprovedCommunication from "./PublicPages/ImprovedCommunication";
import Survey from "./PublicPages/Survey";
import CompetitorAnalysis from "./PublicPages/CompetitorAnalysis";
import Risk from "./PublicPages/Risk";
import Docmangement from "./PublicPages/Docmangement";
import WorkFlowManagement from "./PublicPages/WorkFlowManagement";
import ExpandBusiness from "./PublicPages/ExpandBusiness";
import CampaignManagement from "./PublicPages/CampaignManagement";
import StrongConnection from "./PublicPages/StrongConnection";
import DBIntigration from "./PublicPages/DBIntigration";
import OperationalManagement from "./PublicPages/OperationalManagement";
import CatalogSync from "./PublicPages/CatalogSync";
import SalesGoals from "./PublicPages/SalesGoals";
import PredictiveAnalystics from "./PublicPages/PredictiveAnalystics";
import SupportTicket from "./PublicPages/SupportTicket";
import OAuth2RedirectPage from "./pages/OAuth2RedirectPage";

// ---------- Industry Pages ----------
import Aerospace from "./PublicPages/Aerospace";
import Transport from "./PublicPages/Transport";
import Computer from "./PublicPages/Computer";
import Telecommunication from "./PublicPages/Telecommunication";
import Pharmaceutical from "./PublicPages/Pharmaceutical";
import Food from "./PublicPages/Food";
import Healthcare from "./PublicPages/Healthcare";
import Construction from "./PublicPages/Construction";
import Agriculture from "./PublicPages/Agriculture";
import Education from "./PublicPages/Education";
import Electronics from "./PublicPages/Electronics";

// ---------- Business Pages ----------
import FinanceAndAccounting from "./PublicPages/FinanceAndAccounting";
import GeneralLadger from "./PublicPages/GeneralLadger";
import HumanResource from "./PublicPages/HumanResource";
import ServiceManagement from "./PublicPages/ServiceManagement";
import Ecommerce from "./PublicPages/Ecommerce";
import DocumentManagement from "./PublicPages/DocumentManagement";
import AssetManagement from "./PublicPages/AssetManagement";
import RiskManagement from "./PublicPages/RiskManagement";
import BusinessIntelligence from "./PublicPages/BusinessIntelligence";
import SupplyChainManagement from "./PublicPages/SupplyChainManagement";

// ---------- Accounting Pages ----------
import AccountPayable from "./PublicPages/AccountPayable";
import AccountReceivable from "./PublicPages/AccountReceivable";
import FixedAssets from "./PublicPages/FixedAssets";
import BudgetingAndForecasting from "./PublicPages/BudgetingAndForecasting";
import CashManagement from "./PublicPages/CashManagement";
import TaxManagement from "./PublicPages/TaxManagement";

// ---------- HR Pages ----------
import PayrollManagement from "./PublicPages/PayrollManagement";
import TimeAndAttendence from "./PublicPages/TimeAndAttendence";
import Recruitment from "./PublicPages/Recruitment";
import TalentManagement from "./PublicPages/TalentManagement";
import EmployeDataManagement from "./PublicPages/EmployeDataManagement";
import TraningAndDevelopement from "./PublicPages/TrainingAndDevelopement";
import BenefitsAdministration from "./PublicPages/BenefitsAdministration";

// ---------- SCM Pages ----------
import Procurement from "./PublicPages/Procurement";
import OrderManagement from "./PublicPages/OrderManagement";
import WarehouseManagement from "./PublicPages/WarehouseManagement";
import LogisticsAndShipping from "./PublicPages/LogisticsAndShipping";
import SupplierManagement from "./PublicPages/SupplierManagement";
import InventoryManagementSCM from "./PublicPages/InventoryManagementSCM";
import Manufacturing from "./PublicPages/Manufacturing";
import ProcurementPage from "./PublicPages/ProcurementPage";
import InventoryManagementPage from "./PublicPages/InventoryManagementPage";

// ---------- CRM Pages ----------
import CustomerRelationshipManagement from "./PublicPages/CustomerRelationshipManagement";
import ProjectManagement from "./PublicPages/ProjectManagement";
import SalesAndDistribution from "./PublicPages/SalesAndDistribution";
import SalesForceAutomation from "./PublicPages/SalesForceAutomation";
import CustomerServiceManagement from "./PublicPages/CustomerServiceManagement";
import MarketingAutomation from "./PublicPages/MarketingAutomation";
import LeadAndOpportunity from "./PublicPages/LeadAndOpportunity";

// ---------- Project Management Pages ----------
import ProjectPlanning from "./PublicPages/ProjectPlanning";
import ResourceAllocation from "./PublicPages/ResourceAllocation";
import TimeAndExpenseTracking from "./PublicPages/TimeAndExpenseTracking";
import ProjectAccounting from "./PublicPages/ProjectAccounting";
import ProjectCollaboration from "./PublicPages/ProjectCollaboration";

// ---------- Product & Manufacturing ----------
import ProductPlanning from "./PublicPages/ProductPlanning";
import BillOfMaterials from "./PublicPages/BillOfMaterials";

// ---------- User Components ----------
import CustomerDashboard from "./User/CustomerDashboard";
import DashboardV1 from "./User/DashboardV1";
import VendorDashboard from "./User/VendorDashboard";
import LeadDashboard from "./User/LeadDashboard";
import TaskDashboard from "./User/TaskDashboard";
import InteractionDashboard from "./User/InteractionDashboard";
import InventoryDashboard from "./User/InventoryDashboard";
import Product from "./User/Product";
import Setting from "./User/Setting";
import Company from "./User/Company";
import NotFound from "./User/NotFound";
import UserProfile from "./User/UserProfile";
import EyeSenseDownload from "./User/EyeSenseDownload";

// ---------- User Sections ----------
import CreateTask from "./User/Sections/CreateTask";
import NewCustomer from "./User/Sections/NewCustomer";
import NewVendor from "./User/Sections/NewVendor";
import NewLead from "./User/Sections/NewLead";
import AddProduct from "./User/Sections/AddProduct.jsx";
import AddProd from "./User/Sections/AddProd.jsx";
import CustomerDetailsParent from "./User/Sections/CustomerDetailsParent.jsx";
import LeadDetailsParent from "./User/Sections/LeadDetailsParent.jsx";
import TaskDetailsParent from "./User/Sections/TaskDetailsParent.jsx";
import CreateInvoice from "./User/Sections/CreateInvoice.jsx";
import CreatePurchaseOrder from "./User/Sections/CreatePurchaseOrder.jsx";
import CreateQuotation from "./User/Sections/CreateQuotation.jsx";
import VendorDetailsParent from "./User/Sections/VendorDetailsParent.jsx";
import VendorProducts from "./User/Sections/VendorProducts.jsx";
import RegisterNewUserModal from "./User/components/RegisterNewUserModal.jsx";
import SecureRoutes from "./Utils/SecureRoutes.jsx";
import QuotationListPage from "./pages/Quotation/QuotationListPage";
import QuotationDetailPage from "./pages/Quotation/QuotationDetailPage";
import ImageToText from "./AI/ImageToText.jsx";
import GlobalAIAssistant from "./User/components/GlobalAIAssistant.jsx";
import CookieConsentBanner from "./components/CookieConsent/CookieConsentBanner";
import JournalConfiguration from "./User/Sections/JournalConfiguration.jsx";
import LeadList from "./User/Sections/LeadList.jsx";
import AllLeads from "./User/Sections/AllLeads.jsx";
import AllCustomers from "./User/Sections/AllCustomers.jsx";
import AllVendors from "./User/Sections/AllVendors.jsx";
import CustomerList from "./User/Sections/CustomerList.jsx";
import VendorList from "./User/Sections/VendorList.jsx";
import Configure from "./User/Sections/Configure.jsx";
import FeatureRequestForm from "./User/Sections/FeaturesRequest.jsx";
import CsvImport from "./User/Sections/CsvImport.jsx";
import CsvImport_lead from "./User/Sections/CsvImport_lead.jsx";
import CsvImport_vendor from "./User/Sections/CsvImport_vendor.jsx";
import SendBulkEmail from "./User/Sections/SendBulkEmail.jsx";

// ---------- Enteli Social ----------
import EnteliSocialDashboard from "./User/EnteliSocial/EnteliSocialDashboard";
import EnteliSocialSetting from "./User/EnteliSocial/EnteliSocialSetting";
import EnteliSocialPosts from "./User/EnteliSocial/EnteliSocialPosts";

// ---------- User Management ----------
import ManageUser from "./User/Sections/ManageUser";
import AddEmployee from "./User/Sections/AddEmployee";

// ---------- Expense (previously missing) ----------
import ExpenseDashboard from "./User/Sections/ExpenseDashboard";
import NewExpense from "./User/Sections/NewExpense";

// ---------- Persistent Dashboard Layout ----------
import DashboardLayout from "./User/DashboardLayout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ---------- Protected / Dashboard Routes ---------- */}
        <Route element={<SecureRoutes />}>
          <Route element={<DashboardLayout />}>
            {/* Dashboards */}
            <Route path="/crm-dashboard" element={<DashboardV1 />} />
            <Route path="/inventory-dashboard" element={<InventoryDashboard />} />
            <Route path="/crm-dashboard/inventory-dashboard" element={<InventoryDashboard />} />
            <Route path="/interaction-dashboard" element={<InteractionDashboard />} />
            <Route path="/crm-dashboard/interaction-dashboard" element={<InteractionDashboard />} />
            <Route path="/search-interaction" element={<InteractionDashboard autoFocusSearch={true} />} />
            <Route path="/crm-dashboard/search-interaction" element={<InteractionDashboard autoFocusSearch={true} />} />
            <Route path="/eyesense-download" element={<EyeSenseDownload />} />
            <Route path="/crm-dashboard/eyesense-download" element={<EyeSenseDownload />} />

            {/* Enteli Social */}
            <Route path="/crm-dashboard/enteli-social-redesign-dashboard" element={<EnteliSocialDashboard />} />
            <Route path="/crm-dashboard/enteli-social-redesign-settings" element={<EnteliSocialSetting />} />
            <Route path="/crm-dashboard/enteli-social-redesign-posts" element={<EnteliSocialPosts />} />

            {/* Customer / Lead / Task / Vendor */}
            <Route path="/customer-dashboard" element={<CustomerDashboard />} />
            <Route path="/customer-details/:id" element={<CustomerDetailsParent isVendor={false} />} />
            <Route path="/lead-details/:id" element={<LeadDetailsParent isVendor={false} />} />
            <Route path="/task-details/:id/:index" element={<TaskDetailsParent />} />
            <Route path="/vendor-details/:id" element={<VendorDetailsParent isVendor={true} />} />
            <Route path="/configure" element={<Configure />} />
            <Route path="/journalconfiguration" element={<JournalConfiguration />} />
            <Route path="/create-task" element={<CreateTask onTaskCreated={() => console.log("Task Created!")} />} />
            <Route path="/task-dashboard" element={<TaskDashboard />} />

            {/* Expense / Purchase */}
            <Route path="/expense-dashboard" element={<ExpenseDashboard />} />
            <Route path="/new-expense" element={<NewExpense />} />

            {/* Customer / Vendor / Lead Forms */}
            <Route path="/new-customer" element={<NewCustomer />} />
            <Route path="/edit-customer/:id" element={<NewCustomer />} />
            <Route path="/new-vendor" element={<NewVendor />} />
            <Route path="/new-vendor/:id" element={<NewVendor />} />
            <Route path="/new-lead" element={<NewLead />} />
            <Route path="/edit-lead/:id" element={<NewLead />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/add" element={<AddProd />} />
            <Route path="/csv_import" element={<CsvImport />} />
            <Route path="/CsvImport_lead" element={<CsvImport_lead />} />
            <Route path="/CsvImport_vendor" element={<CsvImport_vendor />} />
            <Route path="/feature-request" element={<FeatureRequestForm />} />
            <Route path="/product" element={<Product />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/vendor-dashboard" element={<VendorDashboard />} />
            <Route path="/lead-dashboard" element={<LeadDashboard />} />
            <Route path="/all-leads" element={<AllLeads />} />
            <Route path="/all-customers" element={<AllCustomers />} />
            <Route path="/all-vendors" element={<AllVendors />} />
            <Route path="/leads/:type" element={<LeadList />} />
            <Route path="/customers/:type" element={<CustomerList />} />
            <Route path="/vendors/:type" element={<VendorList />} />
            <Route path="/modal" element={<RegisterNewUserModal />} />
            <Route path="/my-settings" element={<Setting />} />
            <Route path="/company-settings" element={<Company />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/support-ticket" element={<SupportTicket />} />
            <Route path="/create-invoice" element={<CreateInvoice />} />
            <Route path="/create-purchase-order" element={<CreatePurchaseOrder />} />
            <Route path="/create-quotation" element={<CreateQuotation />} />
            <Route path="/imagetotext" element={<ImageToText />} />
            <Route path="/send-bulk-email" element={<SendBulkEmail />} />

            {/* Quotation Module */}
            <Route path="/quotations" element={<QuotationListPage />} />
            <Route path="/quotations/:id" element={<QuotationDetailPage />} />
          </Route>
        </Route>

        {/* ---------- Public Routes ---------- */}
        <Route path="/" element={<Home />} />
        <Route path="/NotFound" element={<NotFound />} />
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="contact_us" element={<Contact />} />
        <Route path="register" element={<Register />} />
        <Route path="verify-otp" element={<VerifyOtp />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="resources" element={<Resources />} />
        <Route path="features" element={<Features />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="aerospace" element={<Aerospace />} />
        <Route path="transport" element={<Transport />} />
        <Route path="computer" element={<Computer />} />
        <Route path="telecommunication" element={<Telecommunication />} />
        <Route path="financeandaccounting" element={<FinanceAndAccounting />} />
        <Route path="pharmaceutical" element={<Pharmaceutical />} />
        <Route path="food" element={<Food />} />
        <Route path="healthcare" element={<Healthcare />} />
        <Route path="construction" element={<Construction />} />
        <Route path="agriculture" element={<Agriculture />} />
        <Route path="education" element={<Education />} />
        <Route path="electronics" element={<Electronics />} />
        <Route path="communication" element={<Communication />} />
        <Route path="customer_services" element={<CustomerServices />} />
        <Route path="eyesense" element={<EyeSense />} />
        <Route path="career" element={<Career />} />
        <Route path="careerapplynow" element={<ApplyNowForm />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="crmmarketing" element={<CrmMarketing />} />
        <Route path="360degreeview" element={<DegreeView />} />
        <Route path="digitalmobile" element={<DigitalMobile />} />
        <Route path="planning" element={<Planning />} />
        <Route path="crm_analysis" element={<CrmAnalysis />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="digitalmarketing" element={<DigitalMarketing />} />
        <Route path="privacypolicy" element={<PrivacyPolicy />} />
        <Route path="ourstory" element={<OurStory />} />
        <Route path="whychooseus" element={<WhyChooseUs />} />
        <Route path="termsofuse" element={<TermsOfUse />} />
        <Route path="leadmanagement" element={<Lead />} />
        <Route path="inventorymanagement" element={<Inventory />} />
        <Route path="processmanagement" element={<Process />} />
        <Route path="invoicemanagement" element={<InvoiceManagement />} />
        <Route path="contactmanagement" element={<ContactManagement />} />
        <Route path="taskmanagement" element={<TaskManagement />} />
        <Route path="salesautomation" element={<SalesAutomation />} />
        <Route path="salesforecasting" element={<SalesForecasting />} />
        <Route path="generalladger" element={<GeneralLadger />} />
        <Route path="humanresource" element={<HumanResource />} />
        <Route path="servicemanagement" element={<ServiceManagement />} />
        <Route path="assetmanagement" element={<AssetManagement />} />
        <Route path="ecommerce" element={<Ecommerce />} />
        <Route path="riskmanagement" element={<RiskManagement />} />
        <Route path="businessintelligence" element={<BusinessIntelligence />} />
        <Route path="documentmanagement" element={<DocumentManagement />} />
        <Route path="supplychainmanagement" element={<SupplyChainManagement />} />
        <Route path="accountpayable" element={<AccountPayable />} />
        <Route path="accountreceivable" element={<AccountReceivable />} />
        <Route path="fixedassets" element={<FixedAssets />} />
        <Route path="budgetingandforecasting" element={<BudgetingAndForecasting />} />
        <Route path="cashmanagement" element={<CashManagement />} />
        <Route path="taxmanagement" element={<TaxManagement />} />
        <Route path="payrollmanagement" element={<PayrollManagement />} />
        <Route path="timeandattendance" element={<TimeAndAttendence />} />
        <Route path="recruitment" element={<Recruitment />} />
        <Route path="talentmanagement" element={<TalentManagement />} />
        <Route path="employedatamanagement" element={<EmployeDataManagement />} />
        <Route path="traininganddevelopement" element={<TraningAndDevelopement />} />
        <Route path="benefitadministration" element={<BenefitsAdministration />} />
        <Route path="procurement" element={<Procurement />} />
        <Route path="ordermanagement" element={<OrderManagement />} />
        <Route path="warehousemanagement" element={<WarehouseManagement />} />
        <Route path="logisticsandshipping" element={<LogisticsAndShipping />} />
        <Route path="suppliermanagement" element={<SupplierManagement />} />
        <Route path="inventorymanagementscm" element={<InventoryManagementSCM />} />
        <Route path="manufacturing" element={<Manufacturing />} />
        <Route path="cutomarrelationship" element={<CustomerRelationshipManagement />} />
        <Route path="projectmanagement" element={<ProjectManagement />} />
        <Route path="salesanddistribution" element={<SalesAndDistribution />} />
        <Route path="procurementpage" element={<ProcurementPage />} />
        <Route path="inventorymanagementpage" element={<InventoryManagementPage />} />
        <Route path="productplanning" element={<ProductPlanning />} />
        <Route path="salesforceautomation" element={<SalesForceAutomation />} />
        <Route path="billofmaterials" element={<BillOfMaterials />} />
        <Route path="customerservicemanagement" element={<CustomerServiceManagement />} />
        <Route path="marketingautomation" element={<MarketingAutomation />} />
        <Route path="leadandopportunitymanagement" element={<LeadAndOpportunity />} />
        <Route path="projectplanning" element={<ProjectPlanning />} />
        <Route path="resourceallocation" element={<ResourceAllocation />} />
        <Route path="timeandexpensetracking" element={<TimeAndExpenseTracking />} />
        <Route path="projectaccounting" element={<ProjectAccounting />} />
        <Route path="projectcollaboration" element={<ProjectCollaboration />} />
        <Route path="dashboardandreporting" element={<DashboardAndReporting />} />
        <Route path="productivityanalysis" element={<ProductivityAnalysis />} />
        <Route path="emailintegration" element={<EmailIntegration />} />
        <Route path="opportunitymanagement" element={<OpportunityManagement />} />
        <Route path="choosingrightcrm" element={<ChoosingRightCRM />} />
        <Route path="corecrmfeatures" element={<CoreCRMFeatures />} />
        <Route path="optionalcrmfeatures" element={<OptionalCRMFeatures />} />
        <Route path="commoncrmfeatures" element={<CommonCRMFeatures />} />
        <Route path="stablegrowth" element={<StableGrowth />} />
        <Route path="improvedcommunication" element={<ImprovedCommunication />} />
        <Route path="survey" element={<Survey />} />
        <Route path="competitoranalysis" element={<CompetitorAnalysis />} />
        <Route path="risk" element={<Risk />} />
        <Route path="docmangement" element={<Docmangement />} />
        <Route path="workflowmanagement" element={<WorkFlowManagement />} />
        <Route path="expandbusiness" element={<ExpandBusiness />} />
        <Route path="campaignmanagement" element={<CampaignManagement />} />
        <Route path="strongconnection" element={<StrongConnection />} />
        <Route path="dbintigration" element={<DBIntigration />} />
        <Route path="operationalmanagement" element={<OperationalManagement />} />
        <Route path="catalogsync" element={<CatalogSync />} />
        <Route path="salesgoals" element={<SalesGoals />} />
        <Route path="predictiveanalystics" element={<PredictiveAnalystics />} />
        <Route path="/lead-list" element={<LeadList />} />
        <Route path="/oauth2/redirect" element={<OAuth2RedirectPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <GlobalAIAssistant />
      <CookieConsentBanner />
    </BrowserRouter>
  );
}

export default App;